import { gql } from '@apollo/client';
import ACADEMIC_SESSION_FRAGMENT from 'graph/fragments/academic-session';

export default gql`
  mutation updateAcademicSession(
    $where: AcademicSessionWhereInput!
    $data: AcademicSessionUpdateInput!
  ) {
    updateAcademicSession(data: $data, where: $where) {
      ...BaseAcademicSession
    }
  }
  ${ACADEMIC_SESSION_FRAGMENT}
`;
